import { __awaiter } from "tslib";
import { checkIfTranslationsAreMarkedAsFavorite, markTranslationFavorite, removeFavoriteTranslation, } from '@app/services/flashcards.service';
import { COMMON__Undo, COMMON__View, ERROR__networkError__message, FAVORITE__Translation_added_to_favorites, FAVORITE__Translation_of_X_to_Y_is_in_your_favorites, FAVORITE__Translation_of_X_to_Y_removed_from_your_favorites, FAVORITE__Translation_removed_from_favorites, SPEECH__tryAgain, } from '@app/services/i18n.messages';
import { getMessage } from '@app/services/i18n.service';
import { getGlosbeTransferState } from '@app/services/transferState-service';
import { writable } from 'svelte/store';
import { addFloatingMessage } from '../FloatingMessages/FloatingMessages.controller';
import { sendFavoriteAnalyticsEvent } from '@app/services/analytics/analytics-send-event';
export const favoriteTranslations = writable([]);
export function checkFavoriteTranslations() {
    return __awaiter(this, void 0, void 0, function* () {
        const translations = Array.from(document.querySelectorAll(".translation__item__pharse")).map(elem => {
            var _a;
            return ({ element: elem, phrase: ((_a = elem.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '' });
        });
        const transferState = getGlosbeTransferState();
        // check only for logged in users and when user is viewing phrase translation page
        if (transferState.auth.loggedIn && transferState.phrase) {
            try {
                const markedAsFavoriteResponse = yield checkIfTranslationsAreMarkedAsFavorite({
                    l1: transferState.dictionary.l1.code,
                    l2: transferState.dictionary.l2.code,
                    phrase: transferState.phrase,
                    translations: translations.map(elementWithText => elementWithText.phrase),
                });
                const translationsWithMarkers = markedAsFavoriteResponse.existList.map((value, index) => (Object.assign(Object.assign({}, translations[index]), { favorite: value })));
                favoriteTranslations.set(translationsWithMarkers);
            }
            catch (e) {
                console.warn("Can't check for favorite translations", e);
            }
        }
    });
}
export function markTranslationFromCurrentDictionaryAsFavorite(translationPhrase) {
    return __awaiter(this, void 0, void 0, function* () {
        const glosbeTransferState = getGlosbeTransferState();
        const addFavoriteRequest = {
            l1: glosbeTransferState.dictionary.l1.code,
            l2: glosbeTransferState.dictionary.l2.code,
            phrase: glosbeTransferState.phrase || '',
            translation: translationPhrase,
        };
        return markTranslationAsFavorite(addFavoriteRequest);
    });
}
export function markTranslationAsFavorite(addFavoriteRequest) {
    return __awaiter(this, void 0, void 0, function* () {
        sendFavoriteAnalyticsEvent({ action: "markStart" });
        const markFavoriteResponse = yield markTranslationFavorite(addFavoriteRequest);
        if (markFavoriteResponse.status === 200) {
            favoriteTranslations.update(favoriteTranslationsData => {
                let found = false;
                const newFavoriteTranslationsData = favoriteTranslationsData.map(favoriteTranslationsDataItem => {
                    if (favoriteTranslationsDataItem.phrase === addFavoriteRequest.translation) {
                        return Object.assign(Object.assign({}, favoriteTranslationsDataItem), { favorite: true });
                    }
                    return favoriteTranslationsDataItem;
                });
                sendFavoriteAnalyticsEvent({ action: "markDone" });
                return newFavoriteTranslationsData;
            });
            addFloatingMessage({
                title: getMessage(FAVORITE__Translation_added_to_favorites),
                body: getMessage(FAVORITE__Translation_of_X_to_Y_is_in_your_favorites, [addFavoriteRequest.phrase, addFavoriteRequest.translation]),
                type: 'info',
                actions: [
                    {
                        text: getMessage(COMMON__Undo),
                        callback: () => {
                            removeTranslationFromFavorites(addFavoriteRequest);
                        },
                    },
                    {
                        text: getMessage(COMMON__View),
                        primary: true,
                        linkUrl: `/user?tab=favorite&l1=${addFavoriteRequest.l1}&l2=${addFavoriteRequest.l2}`
                    }
                ],
            });
        }
    });
}
export function removeTranslationFromFavoritesFromCurrentDictionary(translationPhrase) {
    return __awaiter(this, void 0, void 0, function* () {
        const glosbeTransferState = getGlosbeTransferState();
        const removeFavoriteRequest = {
            l1: glosbeTransferState.dictionary.l1.code,
            l2: glosbeTransferState.dictionary.l2.code,
            phrase: glosbeTransferState.phrase || '',
            translation: translationPhrase,
        };
        removeTranslationFromFavorites(removeFavoriteRequest);
    });
}
export function removeTranslationFromFavorites(_a) {
    return __awaiter(this, arguments, void 0, function* ({ l1, l2, phrase, translation }) {
        sendFavoriteAnalyticsEvent({ action: "markRemoveStart" });
        const removeFavoriteRequest = { l1, l2, phrase, translation };
        try {
            const markFavoriteResponse = yield removeFavoriteTranslation(removeFavoriteRequest);
            if (markFavoriteResponse.status === 200) {
                favoriteTranslations.update(favoriteTranslationsData => {
                    return favoriteTranslationsData.map(favoriteTranslationsDataItem => {
                        if (favoriteTranslationsDataItem.phrase === removeFavoriteRequest.translation) {
                            return Object.assign(Object.assign({}, favoriteTranslationsDataItem), { favorite: false });
                        }
                        return favoriteTranslationsDataItem;
                    });
                });
                sendFavoriteAnalyticsEvent({ action: "markRemoveDone" });
                addFloatingMessage({
                    title: getMessage(FAVORITE__Translation_removed_from_favorites),
                    body: getMessage(FAVORITE__Translation_of_X_to_Y_removed_from_your_favorites, [removeFavoriteRequest.phrase, removeFavoriteRequest.translation]),
                    type: 'info',
                    actions: [
                        {
                            text: getMessage(COMMON__Undo),
                            callback: () => markTranslationAsFavorite(removeFavoriteRequest),
                        }
                    ],
                });
            }
            return markFavoriteResponse;
        }
        catch (e) {
            console.error("Can't remove translation from favorites", e);
            addFloatingMessage({
                title: getMessage(ERROR__networkError__message),
                body: getMessage(ERROR__networkError__message),
                type: 'error',
                actions: [
                    {
                        text: getMessage(SPEECH__tryAgain),
                        callback: () => markTranslationAsFavorite(removeFavoriteRequest),
                    }
                ],
            });
            throw e;
        }
    });
}
